import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { AccesscontrolService } from '../services/accesscontrol.service';

export const accesscontrolResolver: ResolveFn<void> = async (_route, _state) => {
  const accessControlService = inject(AccesscontrolService);
  await accessControlService.loadUserList();
  await accessControlService.loadSelectableUsers();
};
